// Polyfill for iOS 12 and below:
//
//   https://caniuse.com/intersectionobserver
//
import 'intersection-observer';

import { Component } from 'react';

class IntersectionComponent extends Component {
  constructor(props) {
    super(props);

    this.elementsRefs = props.elements;
    this.observer = null;

    this.handleIntersection = this.handleIntersection.bind(this);
    this.observeIntersection = this.observeIntersection.bind(this);
  }

  handleIntersection(entries) {
    // Check if any part of the elements are outside the viewport
    const elementsInViewport = entries.filter(entry => entry.intersectionRatio === 1).map(entry => entry.target.id);
    const elementsOutOfViewport = entries.filter(entry => entry.intersectionRatio < 1).map(entry => entry.target.id);
    this.props.onOutOfViewport([elementsInViewport, elementsOutOfViewport]);
  }

  observeIntersection() {
    this.elementsRefs.forEach(ref => {
      if (ref.current) {
        this.observer.observe(ref.current);
      }
    });
  }

  render() {
    return null;
  }

  componentDidMount() {
    this.observer = new IntersectionObserver(this.handleIntersection, {threshold: [0, 1]});
    this.observeIntersection();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}

export default IntersectionComponent;
